import { makeStyles } from '@mui/styles';

export default makeStyles(() => ({
    Wrapper: {
        height: "auto",
        width: "100%",
        position: "relative",
    },
    TopRow: {
        display: "flex",
        alignItems: "center",
        gap: "24px",
        height: "50px",
        padding: "0 10px",
    },
    ToMain: {
        fontSize: "20px",
        cursor: "pointer",
    },
    AddButton: {
        marginLeft: "auto !important",
    },
    UserCell: {
        width: "100%",
        '& span': {
            color: "#fc7f03",
        },
    },
}));
